<template>
  <div>
    <h1>Custom selection</h1>
  </div>
</template>

<script>
export default {
  name: 'CustomSelection',
};
</script>
